<template>
  <div v-if="page.about" class="page page-white page-about">
    <div class="page-about-hidden">
      <AboutMainText/>
    </div>
    <div class="about-map">
      <img src="/static/map_white.svg"/>
      <Cities/>
    </div>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';

import AboutMainText from '@/components/AboutMainText';
import Cities from '@/components/Cities';

export default {
  name: 'aboutMap',
  components: {
    AboutMainText,
    Cities,
  },
  computed: mapGetters({
    page: 'page',
  }),
};
</script>


<style>
.page-pseudo .page-about{
  .cities-city--popup{
    p{
      visibility: visible;
      opacity: 1;
    }
  }
  .page-about-hidden{
    pointer-events: none;
  }
  .about-map{
    pointer-events: all;

    img{
      position: relative;
      top: 0;
    }

    .in-viewport & {
      transition: opacity .5s ease-in-out;
    }
  }
  .page-theme-dark &{
    .about-map{
      pointer-events: none;
      opacity: 0;
    } 
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/AboutUsMap.vue